import request from '../../src/state/modules/axios'

export function getModeratorReports(params) {
    return request({
        url: '/api/moderator-reports',
        method:'get',
        params,
    })
}

export function getSchoolReports(params) {
    return request({
        url: '/api/school-reports',
        method:'get',
        params,
    })
}
